import { Box } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { FadeOutContainer, StyledIconButton } from '../components';
import { useSidebarMenu } from '../useSidebarMenu';
import { SidebarMenuHeaderContainer, StyledLogotype } from './styled';
export function SidebarMenuHeader(props) {
    const { children, action } = props;
    const { minimized, toggleMinimized } = useSidebarMenu();
    return (<SidebarMenuHeaderContainer>
      <Box>
        <FadeOutContainer $logotype $minimized={minimized}>
          <StyledLogotype />
        </FadeOutContainer>
        {action || (<StyledIconButton $round appearance="ghost" size="small" onClick={toggleMinimized}>
            <Falcon icon="bars-staggered"/>
          </StyledIconButton>)}
      </Box>
      {children}
    </SidebarMenuHeaderContainer>);
}
